<ion-content>
  @if (badges()) {
	  <div>
      <ion-card class="m-0">
        <ion-card-content class="badge-content">
          @for (badge of badges(); track badge) {
	          <ion-row>
              <input type="checkbox" [(ngModel)]="badge.used">
              <ion-text>{{ badge.name }}</ion-text>
            </ion-row>
          }
	        <ion-row>
            <ion-button (click)="closePopover()">Cancel</ion-button>
            <ion-button (click)="updateBadges()">Apply</ion-button>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </div>
  }
</ion-content>
